export default __webpack_public_path__ + "static/media/hellstrikes4.88191fa4.png";